export default __webpack_public_path__ + "static/media/archi_view5.0646ec87.webp";